export default __webpack_public_path__ + "static/media/permission1.6a2b95c0.png";